function logEmailPopupFlag() {
  localStorage.setItem("emailPopupLogged", 1, 86400 * 7);
  console.log("emailPopupLogged");
} // logEmailPopupFlag
 
if(window.location.search.indexOf("resetemailpopup=") > -1) {
  localStorage.removeItem("emailPopupLogged");
}
 
function initFanclubPopup() {
  if(window.location && window.location.href.indexOf("homeowner") > -1) {
    return;
  }
  setTimeout(execFanclubPopup, 10000);
   
  function execFanclubPopup() {
    if(!localStorage.getItem("emailPopupLogged")) {
      document.body.classList.add('active-modal');
      document.getElementById('fanClubPopup').classList.add('active');
    }
  } // execFanclubPopup
   
} // initFanclubPopup

// initFanclubPopup();

function gotoSignUp() {
 	location.replace("/pages/fragrance-fan-club");
  logEmailPopupFlag();
};

var signUpBtn = document.getElementById('gotoSignUp');
signUpBtn.addEventListener('click', function() {
 	location.replace("/pages/fragrance-fan-club");
  logEmailPopupFlag();
  console.log('signup');
});

function closeFanclubPopup() {
  document.body.classList.remove('active-modal');
  document.getElementById('fanClubPopup').classList.remove('active');
  logEmailPopupFlag();
}
 
var closeBtn = document.getElementById('closePopup');
closeBtn.addEventListener('click', function() {
  closeFanclubPopup();
  console.log('close');
});